import styled from 'styled-components';

import { SPACING } from '~/common/layout-propertis/spacing';
import { Z_INDEX } from '~/common/constants/z-index';

export const PrivateLayoutContainer = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: ${({ theme }) => theme.neutral[950]};
  display: flex;
  flex-direction: row;

  @media (max-width: 750px) {
    flex-direction: column;
    overflow-y: hidden;
  }
`;

export const BodyContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  scrollbar-width: thin;
  padding: ${SPACING._20};
  overflow-x: hidden;
  position: relative;

  @media (max-width: 750px) {
    padding: 0 !important;
    padding-top: ${SPACING._12} !important;
    height: calc(100vh - 80px);
    padding: ${SPACING._20};
    overflow-x: hidden;
  }
`;

/* Envolve o conteúdo da página para pausar hover durante o scroll
   (usePauseHoverOnScroll). Replica o contexto flex do BodyContainer para não
   alterar o layout de páginas que dependem de flex:1/height. */
export const PageContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  width: 100%;
`;

export const MobileSidebarWrapper = styled.div<{
  open: boolean;
}>`
  position: absolute;
  z-index: ${Z_INDEX.MODAL};
  width: ${({ open }) => (open ? '100%' : '0%')};
  transition: width 200ms ease-in-out;
  left: ${({ open }) => (open ? '0' : '-272px')};

  > div {
    pointer-events: ${({ open }) => (open ? 'all' : 'none')};
    opacity: ${({ open }) => (open ? 1 : 0)};
  }
`;
